// src/features/whatsapp/pages/VisitMessagePage.tsx
// Re-cableado a lealify-base (Inc11): mensaje al sumar puntos en una visita (evento visit).
import React from 'react';
import { Repeat } from 'lucide-react';
import EventMessageEditor from '../components/EventMessageEditor';

const VisitMessagePage: React.FC = () => (
  <EventMessageEditor
    eventKey="visit"
    title="Mensaje de Visita"
    subtitle="Agradece automáticamente por WhatsApp cuando un cliente regresa y suma puntos"
    icon={<Repeat className="h-5 w-5 sm:h-6 sm:w-6 mr-2 text-emerald-500" />}
    feature="Mensaje de Visita"
    defaultTemplate="¡Gracias por tu visita, @nombre! Ganaste @puntos puntos (total @total). Te faltan @faltan para @recompensa 🎁"
    variables={[
      { key: '@nombre', label: 'Nombre del cliente', example: 'María' },
      { key: '@negocio', label: 'Nombre de tu negocio', example: 'tu negocio', aliases: ['@marca'] },
      { key: '@sucursal', label: 'Sucursal donde compró (si no hay, el nombre del negocio)', example: 'Sucursal Centro' },
      { key: '@puntos', label: 'Puntos ganados en la visita', example: '10' },
      { key: '@total', label: 'Saldo total del cliente', example: '120', aliases: ['@saldo'] },
      { key: '@faltan', label: 'Puntos que faltan para el premio', example: '30' },
      { key: '@recompensa', label: 'Próxima recompensa', example: 'Café gratis' },
    ]}
    allowImage
    enabledHint={{ on: 'Los clientes recibirán un agradecimiento al sumar puntos', off: 'Activar para agradecer cada visita' }}
    stepGuide={{
      description: 'Cuando un cliente que regresa suma puntos en una visita, el sistema le envía este agradecimiento por WhatsApp automáticamente.',
      steps: ['Cliente suma puntos', 'Sistema detecta visita', 'WhatsApp enviado'],
    }}
    requirementsReady="Todo listo — tus clientes recibirán un agradecimiento en cada visita"
  />
);

export default VisitMessagePage;
